// extracted by mini-css-extract-plugin
export var defaultBg = "header-module--defaultBg--260a7";
export var header = "header-module--header--ae2b0";
export var header__book = "header-module--header__book--02733";
export var header__description = "header-module--header__description--261d8";
export var header__homePage = "header-module--header__home-page--31d60";
export var header__homeTitle = "header-module--header__homeTitle--fd10d";
export var header__homeTitleContainer = "header-module--header__homeTitleContainer--3d25f";
export var header__img = "header-module--header__img--94369";
export var header__newYearButton = "header-module--header__newYearButton--87395";
export var header__newYearCatchphrase = "header-module--header__newYearCatchphrase--d0d88";
export var header__number = "header-module--header__number--e7dbe";
export var header__phone = "header-module--header__phone--0c922";
export var header__title = "header-module--header__title--f4bef";
export var header__topbar = "header-module--header__topbar--b8b19";
export var header__txt = "header-module--header__txt--629c9";
export var header__wrapp = "header-module--header__wrapp--72b86";
export var header__wrappReverse = "header-module--header__wrapp-reverse--20e19";
export var hero_float = "header-module--hero_float--3721d";
export var hero_scroll = "header-module--hero_scroll--690a5";
export var home__scroll = "header-module--home__scroll--3f5c1";
export var home__scrollArrow = "header-module--home__scroll-arrow--2cf95";
export var home__scrollSvg = "header-module--home__scroll-svg--6c4c9";
export var home__scrollTxt = "header-module--home__scroll-txt--228eb";
export var topbar__wrapp = "header-module--topbar__wrapp--4948b";
export var withChildren = "header-module--withChildren--1262a";